import * as React from 'react'

import { Box, Text } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

import PriceDetail from 'modules/billing/components/PriceDetail'
import { usePricingContext } from 'modules/onboarding/components/Pricing/PricingContext'
import {
  BUSINESS_VARIANT,
  DEFAULT_CURRENCY,
  MIN_SEATS,
} from 'modules/onboarding/lib/pricing/plans/utils'

import OrderSummary from './_OrderSummary'

const SummaryCard = () => {
  const {
    allPlans,
    isYearly,
    isCoreEnterpriseMandatory,
    computePerSeatPrice,
    computeTotalPrice,
    getSubscriptionItems,
    activeEmployeesCount,
  } = usePricingContext()
  const seats = activeEmployeesCount
  const seatsFloor = Math.max(MIN_SEATS, seats)
  const selectedCore = allPlans.corePlans.find((plan) => plan.isSelected)
  const activeVariant = selectedCore?.activeVariantType
  const description =
    activeVariant === BUSINESS_VARIANT
      ? i18n.t('pricing_plans.config_plan.business_description')
      : i18n.t('pricing_plans.config_plan.enterprise_description')
  const currency = allPlans.corePlans[0]?.pricing?.currency || DEFAULT_CURRENCY

  const totalPrice = computeTotalPrice(seatsFloor)
  const perSeatPrice = computePerSeatPrice()

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1)
  }

  const commonProps = {
    isYearly: isYearly(),
    bundleSubscriptionItems: getSubscriptionItems(seatsFloor),
    currency,
    seats,
    minimumSeats: seatsFloor,
    perSeatPrice,
    totalPrice,
    disableButton: isCoreEnterpriseMandatory(),
  }

  return (
    <Box
      border={{
        all: {
          width: 's1',
          style: 'solid',
          color: 'grey400',
        },
      }}
      borderRadius={{ all: 'abs008' }}
      gap="s24"
    >
      <Box>
        <Box gap="s8" padding="s24" paddingBottom="s0">
          <Box alignItems="center" flexDirection="row" justifyContent="spaceBetween">
            <Text size="400" color="grey1000" weight="medium">
              {[capitalizeFirstLetter(i18n.t('common.company_name')), activeVariant].join(' ')}
            </Text>
          </Box>
          <Text.Normal>{description}</Text.Normal>
        </Box>
        <PriceDetail.Trial {...commonProps}>
          <Box gap="s24" paddingTop="s0">
            <OrderSummary seats={seatsFloor} currency={currency} />
          </Box>
        </PriceDetail.Trial>
      </Box>
    </Box>
  )
}

export default SummaryCard
